import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { Button } from 'ustore-ui';

import { CustomInputComponent } from '../../../../shared/components/custom-input/custom-input.component';
import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-register-step1',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Button, CustomInputComponent, I18nPipe],
  templateUrl: './register-step1.component.html',
  styleUrls: [
    '../../../../../assets/style/login-register.component.scss',
    '../../register.component.scss'
  ]
})
export class RegisterStep1Component {
  @Input() step1Form!: FormGroup;
  @Input() isLoadingCNPJ = false;
  @Input() loading = false;
  @Input() nextStep!: () => void;
  @Input() goToLogin!: () => void;
  @Input() preventLeadingSpace!: (event: KeyboardEvent) => void;
}


